import 'magnific-popup';

// Popup video
const $popupBtn = $('.js-popup-video');
const popupOptions = {
  type: 'iframe',
  mainClass: 'mfp-fade',
  removalDelay: 160,
  preloader: false,
  fixedContentPos: true
};

if ($popupBtn.closest('.slider__slides').length) {
  $popupBtn.closest('.slider__slides').on('init', function() {
    $popupBtn.magnificPopup(popupOptions);
  });
} else {
  $popupBtn.magnificPopup(popupOptions);
}



// WEBPACK FOOTER //
// ./../src/assets/js/popup.js